<table
  mat-table
  [dataSource]="result"
  multiTemplateDataRows
  class="mat-elevation-z8"
>
  <ng-container matColumnDef="accountManagerName">
    <th mat-header-cell class="header" *matHeaderCellDef>Nome do Gestor</th>
    <td mat-cell *matCellDef="let element">
      {{ element.accountManagerName }}
    </td>
  </ng-container>

  <ng-container matColumnDef="accountManagerDocument">
    <th mat-header-cell class="header" *matHeaderCellDef>CNPJ Gestor</th>
    <td mat-cell *matCellDef="let element">
      {{ element.accountManagerDocument }}
    </td>
  </ng-container>

  <ng-container matColumnDef="settlementTypeId">
    <th mat-header-cell class="header" *matHeaderCellDef>Tipo Liquidação</th>
    <td mat-cell *matCellDef="let element">
      {{ element.settlementTypeId }}
    </td>
  </ng-container>

  <ng-container matColumnDef="isNewShareholder">
    <th mat-header-cell class="header" *matHeaderCellDef>É novo cotista?</th>
    <td mat-cell *matCellDef="let element">
      {{ element.isNewShareholder }}
    </td>
  </ng-container>

  <ng-container matColumnDef="portfolioName">
    <th mat-header-cell class="header" *matHeaderCellDef>Nome do cotista</th>
    <td mat-cell *matCellDef="let element">
      {{ element.portfolioName }}
    </td>
  </ng-container>

  <ng-container matColumnDef="portfolioNameDocument">
    <th mat-header-cell class="header" *matHeaderCellDef>CNPJ do cotista</th>
    <td mat-cell *matCellDef="let element">
      {{ element.portfolioNameDocument }}
    </td>
  </ng-container>

  <ng-container matColumnDef="portfolioNameBank">
    <th mat-header-cell class="header" *matHeaderCellDef>Banco</th>
    <td mat-cell *matCellDef="let element">
      {{ element.portfolioNameBank }}
    </td>
  </ng-container>

  <ng-container matColumnDef="portfolioNameBranch">
    <th mat-header-cell class="header" *matHeaderCellDef>Agência</th>
    <td mat-cell *matCellDef="let element">
      {{ element.portfolioNameBranch }}
    </td>
  </ng-container>

  <ng-container matColumnDef="portfolioNameAccount">
    <th mat-header-cell class="header" *matHeaderCellDef>Conta Corrente</th>
    <td mat-cell *matCellDef="let element">
      {{ element.portfolioNameAccount }}
    </td>
  </ng-container>

  <ng-container matColumnDef="portfolioCetipAccount">
    <th mat-header-cell class="header" *matHeaderCellDef>Conta Cetip</th>
    <td mat-cell *matCellDef="let element">
      {{ element.portfolioCetipAccount }}
    </td>
  </ng-container>

  <ng-container matColumnDef="operationTypeId">
    <th mat-header-cell class="header" *matHeaderCellDef>Tipo de Operação</th>
    <td mat-cell *matCellDef="let element">
      {{ element.operationTypeId }}
    </td>
  </ng-container>

  <ng-container matColumnDef="operationValue">
    <th mat-header-cell class="header" *matHeaderCellDef>Valor da Operação</th>
    <td mat-cell *matCellDef="let element">
      {{ element.operationValue | currency: "R$":"symbol":"1.2-2" }}
    </td>
  </ng-container>

  <ng-container matColumnDef="isNewFund">
    <th mat-header-cell class="header" *matHeaderCellDef>
      Novo Fundo Investido?
    </th>
    <td mat-cell *matCellDef="let element">
      {{ element.isNewFund ? "SIM" : "NÃO" }}
    </td>
  </ng-container>

  <ng-container matColumnDef="fundName">
    <th mat-header-cell class="header" *matHeaderCellDef>Nome do Fundo</th>
    <td mat-cell *matCellDef="let element">
      {{ element.fundName }}
    </td>
  </ng-container>

  <ng-container matColumnDef="fundDocument">
    <th mat-header-cell class="header" *matHeaderCellDef>CNPJ do Fundo</th>
    <td mat-cell *matCellDef="let element">
      {{ element.fundDocument }}
    </td>
  </ng-container>

  <ng-container matColumnDef="fundAccount">
    <th mat-header-cell class="header" *matHeaderCellDef>Conta do Fundo</th>
    <td mat-cell *matCellDef="let element">
      {{ element.fundAccount }}
    </td>
  </ng-container>

  <ng-container matColumnDef="fundAdministrator">
    <th mat-header-cell class="header" *matHeaderCellDef>
      Administrador do Fundo Investido
    </th>
    <td mat-cell *matCellDef="let element">
      {{ element.fundAdministrator }}
    </td>
  </ng-container>

  <ng-container matColumnDef="quotationDate">
    <th mat-header-cell class="header" *matHeaderCellDef>Data de cotização</th>
    <td mat-cell *matCellDef="let element">
      {{ element.quotationDate | date: "dd/MM/yyyy" }}
    </td>
  </ng-container>

  <ng-container matColumnDef="settlementDate">
    <th mat-header-cell class="header" *matHeaderCellDef>Data Liquidação</th>
    <td mat-cell *matCellDef="let element">
      {{ element.settlementDate | date: "dd/MM/yyyy" }}
    </td>
  </ng-container>

  <ng-container matColumnDef="annotations">
    <th mat-header-cell class="header" *matHeaderCellDef>Observação</th>
    <td mat-cell *matCellDef="let element">
      {{ element.annotations }}
    </td>
  </ng-container>

  <!-- Expanded Content Column - The detail row is made up of this one column that spans across all columns -->
  <ng-container matColumnDef="expandedDetail">
    <td
      mat-cell
      *matCellDef="let element"
      [attr.colspan]="ColumnsLiabilities.length"
    >
      <div
        class="example-element-detail"
        [@detailExpand]="element == expandedElement ? 'expanded' : 'collapsed'"
      >
        <div class="example-element-description">
          <div class="title-description">
            <h5>Erros encontrados:</h5>
          </div>
          <ul *ngFor="let error of element.errors">
            <li>
              {{ error }}
            </li>
          </ul>
        </div>
      </div>
    </td>
  </ng-container>

  <tr mat-header-row *matHeaderRowDef="ColumnsLiabilities"></tr>
  <tr
    mat-row
    *matRowDef="let element; columns: ColumnsLiabilities"
    class="example-element-row"
    [class.example-expanded-row]="expandedElement === element"
    (click)="expandedElement = expandedElement === element ? null : element"
  ></tr>
  <tr
    mat-row
    *matRowDef="let row; columns: ['expandedDetail']"
    class="example-detail-row"
  ></tr>
</table>
